import PropTypes from 'prop-types'
import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import * as yup from 'yup'
import { Button, ErrorText, Form, MobileOrEmail, Validator } from '../components'
import * as routeService from '../services/routeService'
import * as networkService from '../services/networkService'
import * as translationService from '../services/translationService'
import { ERROR_INVALID_EMAIL, ERROR_INVALID_PHONE_NUMBER, REQUIRED_FIELD } from './../utils/validation/constants'
import AuthContent from './AuthContent'
import { isPossiblePhone, parseNumber, parsePhoneNumber } from '../utils/phone'
import { isEmpty } from 'lodash'

const mapStateToProps = ({ AuthReducer, FlowReducer }) => {
  const { user = {}, error } = AuthReducer
  const { property } = FlowReducer
  const { phone, mobileNumber, email } = user
  return {
    phoneOrEmail: phone || email || mobileNumber,
    property,
    error,
    user,
  }
}

class ForgotPasswordView extends React.Component {
  constructor(props) {
    super(props)

    this.captchaRef = React.createRef()
  }

  static propTypes = {
    phoneOrEmail: PropTypes.string,
    error: PropTypes.any,
    doLogin: PropTypes.func,
    resetPasswordRequest: PropTypes.func,
    property: PropTypes.any,
    phaseInformationError: PropTypes.any,
    applicationProfileError: PropTypes.any,
  }

  phoneValidation = {
    id: 'phoneOrEmail',
    validation: yup
      .string()
      .test('isValidPhoneNumber', ERROR_INVALID_PHONE_NUMBER, val => {
        if (val === undefined) return true
        if (val.length <= 3) return true
        return !isEmpty(parseNumber(val))
      })
      .required(),
  }

  emailValidation = {
    id: 'phoneOrEmail',
    validation: yup
      .string()
      .email(ERROR_INVALID_EMAIL)
      .required(REQUIRED_FIELD),
  }

  captchaValidation = {
    id: 'captcha',
    validation: yup.string().required(REQUIRED_FIELD),
  }

  state = {
    phoneOrEmail: '',
    captcha: undefined,
    inputValidation: {},
    apiError: '',
  }

  onValueChange = event => {
    this.setState({ apiError: '' })
    const { id, value } = event.target
    this.setState({
      [id]: value,
      inputValidation: {},
    })
  }

  resetErrors = () => {
    this.setState({
      inputValidation: {},
    })
  }

  componentDidMount() {
    const input = this.props.phoneOrEmail
    if (!input) {
      routeService.goToLoginPage()
    } else {
      if (isPossiblePhone(input)) {
        this.setState({ phoneOrEmail: parsePhoneNumber(input) })
      } else {
        this.setState({ phoneOrEmail: input })
      }
    }
  }

  resetPasswordRequest = (phoneOrEmail, captcha, isPhone) => {
    networkService
      .requestResetPasswordReset(phoneOrEmail, captcha, isPhone)
      .then(response => {
        const { data, data: { success } = {} } = response
        console.log('requestResetPasswordReset response', data)

        if (success) {
          if (isPhone) {
            routeService.goToResetPasswordRequestedPage()
          } else {
            routeService.goToResetPasswordLinkRequestedPage()
          }
        } else {
          this.setState({ apiError: translationService.forgotPasswordUserNotFound() })
        }
      })
      .catch(err => {
        console.log('requestResetPasswordReset error', err)

        if (err.response.status === 429) {
          this.setState({ apiError: translationService.forgotPasswordTooManyRequests() })
        } else {
          this.setState({ apiError: translationService.generalError() })
        }

        return Promise.reject(err)
      })
  }

  handleSubmit = event => {
    event.preventDefault()

    let validationRules = [this.captchaValidation]

    const isPhone = isPossiblePhone(this.state.phoneOrEmail)

    if (isPhone) {
      validationRules.push(this.phoneValidation)
    } else {
      validationRules.push(this.emailValidation)
    }

    Validator(validationRules, this.state)
      .then(() => {
        this.setState({
          inputValidation: {},
        })

        if (this.captchaRef.current) {
          this.captchaRef.current.reset()
        }

        this.resetPasswordRequest(this.state.phoneOrEmail, this.state.captcha, isPhone)
      })
      .catch(validationErrors => {
        this.setState({
          inputValidation: validationErrors,
        })
      })
  }

  render() {
    const { error, phaseInformationError, applicationProfileError } = this.props
    const { inputValidation, apiError } = this.state

    return (
      <AuthContent
        title={translationService.forgotPasswordTitle()}
        subtitle={translationService.forgotPasswordSubTitle()}
        hasToken={false}>
        <Form onSubmit={this.handleSubmit}>
          {(phaseInformationError || applicationProfileError) && (
            <ErrorText>{translationService.generalError()}</ErrorText>
          )}

          <MobileOrEmail
            label={translationService.forgotPasswordInputLabel()}
            id="phoneOrEmail"
            value={this.state.phoneOrEmail}
            onChange={this.onValueChange}
            error={inputValidation.phoneOrEmail || (error && translationService.loginPhoneFormatError()) || apiError}
          />

          <ReCAPTCHA
            id="captcha"
            ref={this.captchaRef}
            sitekey={process.env.REACT_APP_CAPTCHA_KEY}
            onChange={value => {
              this.onValueChange({ target: { id: 'captcha', value } })
            }}
          />

          <Button primary submit onClick={this.handleSubmit}>
            {isPossiblePhone(this.state.phoneOrEmail)
              ? translationService.forgotPasswordSendTextMsg()
              : translationService.forgotPasswordSendResetLink()}
          </Button>
          <div>
            <Button plain onClick={() => routeService.goToLoginPage()}>
              {translationService.authToLogin()}
            </Button>
          </div>
        </Form>
      </AuthContent>
    )
  }
}

export default compose(
  translate('translations'),
  connect(mapStateToProps),
)(ForgotPasswordView)



// WEBPACK FOOTER //
// ./src/views/ForgotPasswordView.js